import classes from "./BouncingBall.module.css";
// import { useState } from "react";

function BouncingBall({pending}) {
//   const [state, setState] = useState({ pending: pending });
//   if (state.pending) {
//     return (
//       <div className={classes.spinner}>
//         <div className={classes["loadingio-spinner-ball-1xrm5md8nzz"]}>
//           <div className={classes["ldio-soaatbg5y7m"]}>
//             <div></div>
//           </div>
//         </div>
//       </div>
//     );
//   } else {
//     return null;
//   }

  return (
    <div className={classes.spinner}>
      <div className={classes["loadingio-spinner-ball-1xrm5md8nzz"]}>
        <div className={classes["ldio-soaatbg5y7m"]}>
          <div></div>
        </div>
      </div>
    </div>
  );
}

export default BouncingBall;
